/**
 * Component: Password Modal
 * -----------------------------------------------------------------------------
 */

/**
 * Global variables.
 */
const ACTIVE_CLASS = 'is-active';

/**
 * DOM selectors.
 */
const selectors = {
  openModal: '[js-password-modal-trigger]',
  closeModal: '.password-modal__close',
  passwordModal: '.password-modal',
  passwordModalContent: '.password-modal__inner',
  formErrors: '.errors'
};

/**
 * DOM Node elements.
 */
const nodeElements = {
  passwordModal: document.querySelector(selectors.passwordModal),
  formErrors: document.querySelector(selectors.formErrors)
};

/**
 * Set Event listeners.
 *
 * @description Adds event listeners to open and close the password modal.
 */
function setEventListeners() {
  document.body.addEventListener('click', (e) => {
    const openPopupTarget = e.target.closest(selectors.openModal);
    const closePopupTarget = e.target.closest(selectors.closeModal);
    const passwordContentTarget = e.target.closest(selectors.passwordModalContent);

    const isOpened = Boolean(
      nodeElements.passwordModal?.classList.contains(ACTIVE_CLASS)
    );

    if (openPopupTarget && !isOpened) {
      openModal();
      return;
    }

    /**
     * Close the modal when clicking on the close button or outside the modal.
     */
    if (
      isOpened &&
      (closePopupTarget ||
      (!closePopupTarget && !passwordContentTarget))
    ) {
      closeModal();
      return;
    }
  });
}
/**
 * Open the password modal.
 *
 * @description Adds the `is-active` class to display the modal.
 */
function openModal() {
  nodeElements.passwordModal?.classList.add(ACTIVE_CLASS);
}

/**
 * Close the password modal.
 *
 * @description Removes form errors and `is-active` class to hide the modal.
 */
function closeModal() {
  nodeElements.formErrors?.remove();
  nodeElements.passwordModal?.classList.remove(ACTIVE_CLASS);
}

/**
 * Initialise component.
 */
window.addEventListener('DOMContentLoaded', () => {
  setEventListeners();
});
